import { memo, useEffect, useState } from 'react';
import { CardContent, Grid, Box, Button, Chip, TextField, FormControl, Typography, MenuItem, Checkbox } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { useDispatch, useSelector } from 'react-redux';
import { useForm, Controller } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';
import { useTMutation } from '../../../../../utils/useTMutation';
import showToast from '../../../../../components/Hot-Toast/showToast';
import { useTQuery } from '../../../../../utils/useTQuery';
import { nextStep, previousStep, update } from '../../../../../slice/multiStepSlice';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';

// Define schema for form validation
// export const roleSchema = z.object({
//     SPECILTY_ID: z.array(z.string()).min(1, { message: "At least one role must be selected" }),
// });
export const roleSchema = z.object({
    SPECILTY_ID: z.array(z.string()), // No minimum by default, we’ll handle the requirement conditionally
    setAllRoles: z.boolean(),
}).refine((data) => {
    // Only validate SPECILTY_ID if setAllRoles is false
    if (!data.setAllRoles) {
        return data.SPECILTY_ID.length > 0; // Ensure at least one specialty is selected
    }
    return true;
}, {
    message: "At least one specialty must be selected",
    path: ["SPECILTY_ID"], // This is the field that the error message will be associated with
});


const AssignSpeciality = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { values } = useSelector((state) => state?.multiStep)
    const [specialtyRole, setSpecialtyRole] = useState([]);
    const [selectedRoles, setSelectedRoles] = useState([]);
    const [isAllRolesSelected, setIsAllRolesSelected] = useState(false);
    const { data: specialitiesList } = useTQuery(
        "specialties",
        "/specialty",
        "post"
    );

    useEffect(() => {
        if (specialitiesList?.STATUS) {
            setSpecialtyRole(specialitiesList.OUTPUT);
        }
    }, [specialitiesList]);

    useEffect(() => {
        if (values.specialties) setSelectedRoles(values.specialties?.map(specialty => specialty.specialityID));
    }, [values.specialties])
    const {
        control,
        handleSubmit, watch,
        setValue,
        clearErrors,
        trigger,
        formState: { errors },
    } = useForm({
        resolver: zodResolver(roleSchema),
        defaultValues: { SPECILTY_ID: values.specialties?.map(specialty => specialty.specialityID) || [] },
    });
    console.log('values.specialties', values.specialties?.map(specialty => specialty.specialityID));

    const { mutateAsync } = useTMutation("/addCertificate", "post", (response) => {
        return response
    });
    const showChipList = watch('setAllRoles');
    const listSPECILTY_ID = watch('SPECILTY_ID');

    console.log("values", values);
    const submitJobRole = async (formData) => {


        try {
            const payload = {
                ...formData,
                type: values.TYPE,
                SPECILTY_ID: showChipList ? [] : listSPECILTY_ID,
                ID: values?.ID,
            }
            // console.log("payload", payload); return;
            const response = await mutateAsync(payload);
            if (response.STATUS) {
                showToast("success", response.MESSAGE, 3000);
                dispatch(update({ SPECILTY_ID: payload?.SPECILTY_ID }));
                dispatch(nextStep());
            } else {
                showToast("error", response.MESSAGE, 3000);
            }

        } catch (error) {
            console.error("Add Request failed:", error);
            showToast("error", "Something went wrong, Please try again", 3000);
        }
    };

    const handleChipDelete = (roleId) => {
        setSelectedRoles((prev) => prev.filter(id => id !== roleId));
        setValue('SPECILTY_ID', selectedRoles.filter(id => id !== roleId));
        clearErrors('SPECILTY_ID');
    };

    const handleRoleChange = (event) => {
        const selectedRoleId = event.target.value;
        console.log("vgdsc", selectedRoleId)
        if (selectedRoleId && !selectedRoles.includes(selectedRoleId)) {
            const updatedRoles = [...selectedRoles, selectedRoleId];
            console.log("sdbfjsbj", updatedRoles)
            setSelectedRoles(updatedRoles);
            setValue('SPECILTY_ID', updatedRoles);

            trigger('SPECILTY_ID'); 
        }
    };

    const handleCheckboxChange = (event) => {
        const isChecked = event.target.checked;

        setIsAllRolesSelected(isChecked);

        if (isChecked) {
            setSelectedRoles([]);
            // Select all specialtyRole
            const allRoleIds = specialtyRole.map((role) => role.ID);
            setSelectedRoles(allRoleIds);
            setValue('SPECILTY_ID', allRoleIds);
        } else {
            // Clear all selections
            setSelectedRoles([]);
            setValue('SPECILTY_ID', []);
        }
        clearErrors('SPECILTY_ID');
    };


    return (
        <>

       {!values.REDIRECT && <Button
                onClick={() => dispatch(previousStep())}
                startIcon={<ArrowBackIosIcon sx={{ fontSize: "12px", color: "#000000" }} />}
                sx={{ textTransform: 'none', fontWeight: 500, fontSize: "14px", padding: 3, minWidth: 0 }}
            >
            </Button>}   
            <Grid lg={12} >

                <CardContent >
                    <Typography variant="h2" component="div"  fontWeight="bold" style={{marginTop:-4}}>
                        Assign to Specialties
                    </Typography>
                    <form onSubmit={handleSubmit(submitJobRole)}>
                        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                            <FormControl fullWidth margin="normal">
                                <Controller
                                    name="SPECILTY_ID"
                                    control={control}
                                    render={({ field }) => (
                                        <TextField
                                            select
                                            label="Specialty"
                                            value=""
                                            onChange={handleRoleChange}
                                            error={!!errors.SPECILTY_ID}
                                            helperText={errors.SPECILTY_ID?.message}
                                            sx={{
                                                '& .MuiOutlinedInput-input': {
                                                    padding: 1.814
                                                },
                                            }}
                                        >
                                            <MenuItem disabled value="">Job Role</MenuItem>
                                            {specialtyRole.map((role) => (
                                                <MenuItem key={role.ID} value={role.ID}>
                                                    {role.SPECIALTY_NAME}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    )}
                                />
                                {/* {errors.SPECILTY_ID && <Typography color="error">{errors.SPECILTY_ID.message}</Typography>} */}
                            </FormControl>

                            {/* {!showChipList && 
                            <Box sx={{ mt: 2 }}>
                                <Grid container spacing={1}>
                                    {selectedRoles.map((roleId) => (
                                        <Grid item xs={4} key={roleId}>
                                            <Chip
                                                label={specialtyRole.find(role => role.ID === roleId)?.SPECIALTY_NAME}
                                                onDelete={() => handleChipDelete(roleId)}
                                                sx={{ borderRadius: 0.9 }}
                                            />
                                        </Grid>
                                    ))}
                                </Grid>
                            </Box>
                            } */}
                             <Box style={{marginTop:-10}}>
                                <Grid container spacing={1}>
                                    {selectedRoles.map((roleId) => (
                                        <Grid item xs={4} key={roleId}>
                                            <Chip
                                                label={specialtyRole.find(role => role.ID === roleId)?.SPECIALTY_NAME}
                                                onDelete={() => handleChipDelete(roleId)}
                                                sx={{ borderRadius: 0.9 }}
                                            />
                                        </Grid>
                                    ))}
                                </Grid>
                            </Box>
                            <Box sx={{ display: 'flex', alignItems: 'center',marginTop:-2 }}>
                                <Controller
                                    name="setAllRoles"
                                    control={control}
                                    defaultValue={false} // Default state of the checkbox
                                    render={({ field }) => (
                                        <Checkbox
                                            {...field}
                                            sx={{ padding: 0 }}
                                            error={!!errors.SPECILTY_ID}
                                            helperText={errors.SPECILTY_ID?.message}
                                            checked={field.value}
                                            onChange={(event) => {
                                                field.onChange(event.target.checked); // Update form value
                                                handleCheckboxChange(event); // Call existing function to select/deselect all specialtyRole
                                            }}
                                        />
                                    )}
                                />
                                <Typography sx={{ padding: 1.694 }}>Set for all Speciality</Typography>
                            </Box>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                {/* <Button variant="outlined" onClick={() => dispatch(previousStep())}>
                                    Back
                                </Button> */}
                                    <Typography
                              mt={1}
                              sx={{ color: "#000000", opacity: "60%", fontSize: "14px", cursor: "pointer" }}
                        // onClick={() => dispatch(nextStep())}
                    >
                        Skip
                    </Typography>
                                <Button
                                    // variant="contained" sx={{ backgroundColor: '#6ebe44' }} 
                                    className='gradientAdminThemeColor'
                                    type='submit'>
                                    Next
                                </Button>
                            </Box>
                           
                        </Box>
                    </form>
                </CardContent>
            </Grid>
        </>
    );
};

export default memo(AssignSpeciality);
